// MIRRORS: panel/services/sessionEnd.ts — identical copy; edit both, or delete this line on both to declare a deliberate split.
/**
 * Which 401s mean the session this app thought it had is over.
 *
 * The reason code alone cannot say: `missing_token` is both a signed-out
 * visitor and a signed-in user whose cookie has just lapsed. Hence the second
 * input — whether a user was cached client-side.
 */
const SESSION_END_REASONS: ReadonlySet<string> = new Set([
  'token_expired',
  'missing_token',
  'invalid_token',
  'verification_failed',
]);

export const isSessionEndingReason = (reason: string | undefined): boolean =>
  reason !== undefined && SESSION_END_REASONS.has(reason);

/** @param sessionBelievedActive whether the app is rendering as signed in. */
export const endsBelievedSession = (
  reason: string | undefined,
  sessionBelievedActive: boolean
): boolean => sessionBelievedActive && isSessionEndingReason(reason);
